export default "<span class=\"date\"><ng-content></ng-content>{{ getDateText() }}</span>\r\n"